import React from 'react';
import { Navigate } from 'react-router-dom';
// import { toast } from 'react-toastify'; //? React-Toastify

export const ProtectedRoutes = ({ children }) => {
  // from localstorage
  const token = localStorage.getItem('token');
  const userId = localStorage.getItem('userId');

  if (!token && !userId) {
    return <Navigate to='/login' />;
  }

  return children;
};
